import cn from 'clsx'
import React, { Dispatch, FC, SetStateAction } from 'react'
import s from './VariantSquare.module.css'
import type { Product } from '@commerce/types/product'
import { SelectedOptions } from '@components/product/helpers'
import { decimalToFraction, getFirstOpSize } from './helpers'

export interface VariantSquareProps {
  optionType?: string
  optionValue?: string | undefined
  className?: string
  variants: string[]
  setVariantSettings: Dispatch<
    SetStateAction<{
      metal: string
      diam_type: string
      tcw: string
      size: string
    }>
  >
  variantSettings: {
    metal: string
    diam_type: string
    tcw: string
    size: string
  }
  setSelectedOptions?: React.Dispatch<React.SetStateAction<SelectedOptions>>
  product: Product
  currentFilters: string[]
  productType?: string
}

const VariantSquare: FC<VariantSquareProps> = (props) => {
  const {
    className,
    setVariantSettings,
    variantSettings,
    variants,
    optionType,
    product,
    currentFilters,
    productType,
  } = props

  const rootClassName = cn(s.root, className)

  const extractNumber = (value: string) => {
    const number = parseFloat(value.split('ct')[0])
    return isNaN(number) ? 0 : number
  }

  const sortedVariants = [...variants].sort((a, b) => extractNumber(a) - extractNumber(b))

  const handleOnCLick = (vl: string) => {
    if (optionType === 'TCW' && vl) {
      const firstOpt = getFirstOpSize(
        product,
        variantSettings,
        currentFilters,
        vl
      )
      setVariantSettings((prev) => ({
        ...prev,
        tcw: vl,
        size: firstOpt,
      }))
      return
    }

    setVariantSettings((prev) => ({ ...prev, size: vl }))
  }

  return (
    <div className={rootClassName}>
      <div className={s.header}>
        <span className={s.type}>
          {optionType === 'TCW' ? 'Diamond Carat' : optionType?.toLowerCase()}:
        </span>
        <span className={s.title}>
          {optionType === 'TCW' &&
          productType?.toLowerCase() === 'earring' &&
          !isNaN(Number(variantSettings.tcw.split('ct')[0])) &&
          Number(variantSettings.tcw.split('ct')[0]) !== 0
            ? `${decimalToFraction(
                Number(variantSettings.tcw.split('ct')[0])
              )}ct`
            : optionType === 'TCW' && !['', '0ct'].includes(variantSettings.tcw)
            ? variantSettings.tcw
            : variantSettings.size !== ''
            ? variantSettings.size
            : '-'}
          {optionType === 'TCW' && variantSettings.tcw !== '' ? '. tw.' : ''}
        </span>
      </div>
      <div className={s.container}>
        {sortedVariants.map((vl) => {
          return (
            <div
              className={cn(s.label, {
                '!border-accent-9':
                  (optionType === 'TCW' && variantSettings.tcw === vl) ||
                  (optionType === 'SIZE' && variantSettings.size === vl),
              })}
              key={vl}
              onClick={() => handleOnCLick(vl)}
            >
              <span>
                {optionType === 'TCW' &&
                productType?.toLowerCase() === 'earring' &&
                !isNaN(Number(vl.split('ct')[0]))
                  ? decimalToFraction(Number(vl.split('ct')[0]))
                  : vl.split('ct')[0]}
              </span>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default React.memo(VariantSquare)
